"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addBlock = addBlock;
exports.addBlocksFromSpec = addBlocksFromSpec;
var _BlockManager = require("../BlockManager");
var _block = require("../block");
var _reactivity = require("@vue/reactivity");
function addBlocksFromSpec(root, spec) {
  let layer = [[root, spec]];
  let nextLayer = [];
  while (layer.length > 0) {
    for (let [manager, blockSpec] of layer) {
      for (let child of blockSpec) {
        var _extraParams;
        let extraParams;
        if (child.block.type === "repeat") {
          extraParams = {
            spec: child.block.children
          };
        }
        let block = addBlock(child.block, root.registry, manager, extraParams);
        if (child.block.children && !((_extraParams = extraParams) !== null && _extraParams !== void 0 && _extraParams.spec)) {
          nextLayer.push([block, child.block.children]);
        }
      }
    }
    layer = nextLayer;
    nextLayer = [];
  }
}
function addBlock(blockSpec, registry, parent, extraParameters, position) {
  let block;
  if (!blockSpec.vars) {
    blockSpec.vars = [];
  }
  if (!blockSpec.param) {
    blockSpec.param = {};
  }
  if (!blockSpec.classes) {
    blockSpec.classes = [];
  }
  if (!blockSpec.children) {
    blockSpec.children = [];
  }
  if (!blockSpec.act) {
    blockSpec.act = [];
  }
  let spec = (0, _reactivity.reactive)(blockSpec);
  let param = spec.param;
  if (spec.type === "repeat") {
    if (extraParameters !== null && extraParameters !== void 0 && extraParameters.spec) {
      block = new _block.RepeatBlockManager(spec, new _block.RepeatBlock(param, registry.variableTypes), extraParameters.spec, registry);
    } else {
      throw new Error("Repeat block missing parameters");
    }
  } else {
    block = new _BlockManager.BlockManager(spec, registry.blocks.types.create(spec.type, param, registry.variableTypes), registry);
  }
  if (parent) {
    parent.addChild(block, position);
    block.addContext();
  }
  return block;
}
//# sourceMappingURL=block.js.map